import type IAffiliationInformation from "@api/models/IAfiliationInformation";
import StringHelper from "@helpers/StringHelper";
import { create } from "zustand";
import { persist } from "zustand/middleware";

export type IAffiliationInformationStore = IAffiliationInformation & {
  // zustand stores it as a string
  // so to make it explicit, the props is a string too
  lastUpdatedAt: string;
};

interface UserStore {
  token: undefined | string;
  affiliationInformation: undefined | IAffiliationInformationStore;
  isLogin: boolean;
  setToken: (token?: string) => void;
  setAffiliationInformation: (
    affiliationInformation: IAffiliationInformationStore,
  ) => void;
  logout: () => void;
}

const useUserStore = create<UserStore>()(
  persist(
    (set) => ({
      token: undefined,
      affiliationInformation: undefined,
      isLogin: false,
      setToken: (token) => {
        set({ token, isLogin: StringHelper.isNotEmpty(token) });
      },
      setAffiliationInformation: (affiliationInformation) => {
        set({
          affiliationInformation,
        });
      },
      logout: () => {
        set({
          isLogin: false,
          token: undefined,
          affiliationInformation: undefined,
        });
      },
    }),
    { name: "SecretSmurfsStoreUser" },
  ),
);

export default useUserStore;

export const forceLogoutUser = () => {
  useUserStore.getState().logout();
};

export const getUserToken = (): string | undefined => {
  return useUserStore.getState().token;
};
